import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation changeClientEmail($cardId: ID!, $email: String!) {
      changeClientEmail(cardId: $cardId, email: $phone) {
        emailChanged
      }
    }
  `,
  config: {
    options: ({ cardId, email }) => ({
      variables: {
        cardId,
        email,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/client/changeClientEmail.js